/**
 * QUÉ PARTES DE LA APP ESTÁN PRENDIDAS.
 *
 * Lo decide la administración de Tennis Up Club y lo lee cualquiera, con sesión o
 * sin ella: la pantalla de inicio tiene que saber si dibuja la tarjeta de
 * memes antes de saber quién mira.
 *
 * ARRANCA EN PRENDIDO Y NO EN APAGADO, y eso no es un detalle. Mientras la
 * respuesta viaja no se sabe nada, y hay que elegir qué mostrar en ese
 * instante: apagado significa que una conexión lenta hace parpadear la
 * tarjeta —aparece, desaparece, vuelve— y que un servidor caído deja la app
 * sin secciones. Prendido significa que apagar los memes tarda un segundo más
 * en verse, que es lo que cuesta menos de las dos.
 *
 * UNA SOLA PETICIÓN POR CARGA DE LA APP. La respuesta se guarda en una
 * promesa a nivel de módulo: diez pantallas que pregunten reciben la misma, y
 * no diez peticiones iguales. No se refresca sola —un interruptor de la
 * plataforma cambia cada varios meses, no cada minuto— y quien apague algo lo
 * ve en el siguiente arranque.
 */
import { useEffect, useState } from 'react';
import type { PlatformFeatures } from '@tennisup/contracts';

import { api } from '../lib/api';

/** Lo que se cree mientras no se sabe: todo prendido. */
const TODO_PRENDIDO: PlatformFeatures = { memes: true };

let enVuelo: Promise<PlatformFeatures> | null = null;

function cargar(): Promise<PlatformFeatures> {
  enVuelo ??= api
    .platformFeatures()
    .then((f) =>
      // El tipo es una promesa sobre el contrato, no una garantía sobre el
      // cable: un `memes` que no sea booleano no apaga nada.
      typeof f?.memes === 'boolean' ? { memes: f.memes } : TODO_PRENDIDO,
    )
    .catch(() => TODO_PRENDIDO);
  return enVuelo;
}

/** Para las pruebas: olvida lo que se respondió. */
export function olvidarFeatures(): void {
  enVuelo = null;
}

export function useFeatures(): PlatformFeatures {
  const [features, setFeatures] = useState<PlatformFeatures>(TODO_PRENDIDO);

  useEffect(() => {
    let vivo = true;
    void cargar().then((f) => {
      if (vivo) setFeatures(f);
    });
    return () => {
      vivo = false;
    };
  }, []);

  return features;
}
